import React, { useEffect } from 'react';
import BitaModal from '../../../../../../bitaComponents/BitaModal/BitaModal';
import BitaButton from '../../../../../../bitaComponents/BitaButton/BitaButton';
import IndexSlider from '../SliderTickers/IndexSlider';
import BasketErrorsSubtitle from './BasketErrorsSubtitle';
import BasketErrorsTable from './BasketErrorsTable';
import styles from './BasketErrorsModal.module.scss';

const BasketErrorsModal = ({
  errorsCount,
  showModal,
  closeModal,
  errorsModalData,
  sliderBaskets,
  selectedIndex,
  setSelectedIndex,
  onGoFix,
}) => {
  const errorRows = Array.isArray(errorsModalData) ? errorsModalData : [];
  const normalizedSliderBaskets = Array.isArray(sliderBaskets) ? sliderBaskets : [];

  useEffect(() => {
    const isSelectedIndexInSliderBaskets = normalizedSliderBaskets.some(
      basket => basket.symbol === selectedIndex,
    );
    if (selectedIndex && !isSelectedIndexInSliderBaskets) {
      setSelectedIndex(normalizedSliderBaskets[0].symbol);
    }
  }, [showModal]);

  return (
    <BitaModal isModalOpen={showModal} setModalState={closeModal} customStyle={{ width: '80%' }}>
      <div className={styles.basketErrorsModalContainer}>
        <div className={styles.basketErrorsModalHeader}>
          <div className={styles.basketErrorsModalTitle}>Basket Errors Detected</div>
        </div>

        <div className={styles.basketErrorsModalContent}>
          <div className={styles.basketErrorsModalIndexesContainer}>
            <IndexSlider
              indexes={normalizedSliderBaskets}
              selectedIndex={selectedIndex}
              setSelectedIndex={setSelectedIndex}
            />
          </div>
          <div className={styles.basketErrorsModalTableContainer}>
            <BasketErrorsSubtitle
              errorsCount={errorsCount}
              sliderBaskets={normalizedSliderBaskets}
            />
            <BasketErrorsTable errorRows={errorRows} onGoFix={onGoFix} />
          </div>
        </div>

        <div className={styles.basketErrorsModalFooter}>
          <BitaButton
            className={styles.basketErrorsModalCloseButton}
            width="10%"
            onClick={closeModal}
          >
            Close
          </BitaButton>
        </div>
      </div>
    </BitaModal>
  );
};

export default BasketErrorsModal;
